import { useI18n } from 'hooks/useI18n';
import {
  CartesianGrid,
  Legend,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis
} from 'recharts';
import MethodologyAnchor from '../MethodologyAnchor';
import { StyledRecharts } from './Recharts.styled';

const AverageSalaryByLanguage: React.FC = () => {
  const { t } = useI18n('state-of-the-sector');

  const data = [
    {
      years: '',
      JavaScript: 23.53045685279188,
      JAVA: 24.725,
      Python: 25.72340425531915,
      PHP: 25.5,
      TypeScript: 24.37837837837838,
      'C#': 25.333333333333332,
      'C++': 24.526315789473685,
      Bash: 25,
      Kotlin: 23.571428571428573,
      C: 25.63157894736842
    },
    {
      years: '<2y',
      JavaScript: 26.06553755522828,
      JAVA: 27.08128834355828,
      Python: 28.050675675675677,
      PHP: 25.473529411764705,
      TypeScript: 26.462162162162162,
      'C#': 26.82278481012658,
      'C++': 28.1171875,
      Bash: 26,
      Kotlin: 26.333333333333332,
      C: 27.48979591836735
    },
    {
      years: '2-5y',
      JavaScript: 37.70332850940666,
      JAVA: 39.10986547085202,
      Python: 42.536307053941904,
      PHP: 36.838174273858925,
      TypeScript: 41.08870967741936,
      'C#': 39.1546762589928,
      'C++': 41.69047619047619,
      Bash: 42.86764705882353,
      Kotlin: 41.669642857142854,
      C: 38.714285714285715
    },
    {
      years: '5-10y',
      JavaScript: 48.841137123745824,
      JAVA: 51.4578313253012,
      Python: 52.87290502793296,
      PHP: 45.51851851851852,
      TypeScript: 51.8891129032258,
      'C#': 49.02189781021898,
      'C++': 49.350746268656714,
      Bash: 50.82051282051282,
      Kotlin: 55.386597938144334,
      C: 48.19736842105263
    },
    {
      years: '>10y',
      JavaScript: 54.98192771084337,
      JAVA: 58.50574712643679,
      Python: 59.07309941520468,
      PHP: 52.496815286624205,
      TypeScript: 59.931472081218274,
      'C#': 54.22291666666666,
      'C++': 59.01748251748251,
      Bash: 55.859375,
      Kotlin: 61.318681318681314,
      C: 56.5625
    }
  ];

  return (
    <div>
      <StyledRecharts>
        <ResponsiveContainer height={400}>
          <LineChart data={data} margin={{ left: 10, bottom: 20 }}>
            <CartesianGrid strokeDasharray="1 1 " />
            <XAxis
              dataKey="years"
              tickLine={false}
              tickMargin={8}
              label={{
                value: t('salaries.average-by-language.years-label'),
                position: 'insideBottom',
                offset: -13,
                style: { transformOrigin: 'center center' }
              }}
            />
            <YAxis
              tickLine={false}
              tickMargin={10}
              tickFormatter={(tick) => {
                return `€${tick}K`;
              }}
              label={{
                value: t('salaries.average-by-language.salary-label'),
                position: 'insideLeft',
                offset: -8,
                angle: -90
              }}
            />
            <Tooltip
              cursor={{ fill: 'transparent' }}
              labelStyle={{
                borderBottom: '1px solid #4d485c',
                marginBottom: '6px',
                fontWeight: 900
              }}
              separator=": "
              formatter={(value: number) => '€' + value.toFixed(1) + 'K'}
              labelFormatter={(label: string) =>
                label + ' ' + t('salaries.average-by-language.tooltip-years')
              }
              wrapperClassName="tooltip-x"
            />
            <Legend
              layout="vertical"
              align="right"
              verticalAlign="top"
              iconType="square"
              width={120}
            />
            <Line
              dataKey="JavaScript"
              dot={false}
              strokeWidth={2}
              stroke="#666666"
            />
            <Line dataKey="JAVA" dot={false} strokeWidth={2} stroke="#E7278A" />
            <Line
              dataKey="Python"
              dot={false}
              strokeWidth={2}
              stroke="#E41B1E"
            />
            <Line dataKey="PHP" dot={false} strokeWidth={2} stroke="#E3A702" />

            <Line
              dataKey="TypeScript"
              dot={false}
              strokeWidth={2}
              stroke="#65A41E"
            />
            <Line dataKey="C#" dot={false} strokeWidth={2} stroke="#A6761D" />
            <Line dataKey="C" dot={false} strokeWidth={2} stroke="#D95F02" />
            <Line dataKey="C++" dot={false} strokeWidth={2} stroke="#1B9D76" />
            <Line dataKey="Bash" dot={false} strokeWidth={2} stroke="#746FB3" />
            <Line
              dataKey="Kotlin"
              dot={false}
              strokeWidth={2}
              stroke="#1E77B3"
            />
          </LineChart>
        </ResponsiveContainer>
      </StyledRecharts>
      <MethodologyAnchor />
    </div>
  );
};

export default AverageSalaryByLanguage;
